import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import api from '../../api';
import Form from '../form';
import Button from '../button';
import TextArea from '../textarea';
import Loader from '../loader';
import './indexed-search-create.css';

const defaultIndexedSearchCreate = {
  texts: '',
};

const defaultErrors = {
  texts: [],
};

const IndexedSearchCreate = () => {
  const [indexedSearchCreate, setIndexedSearchCreate] = useState(defaultIndexedSearchCreate);
  const [errors, setErrors] = useState(defaultErrors);
  const [isLoading, setIsLoading] = useState(false);
  const [redirect, setRedirect] = useState('');

  const handleChange = e => {
    setIndexedSearchCreate({
      ...indexedSearchCreate,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: [],
    });
  };

  const handleSubmit = e => {
    const apiMethod = api.indexedSearches.importTexts;
    const apiParams = { texts: indexedSearchCreate.texts };

    e.preventDefault();
    setIsLoading(true);
    apiMethod(
      apiParams,
      () => {
        setRedirect('/recherches-indexees');
      },
      err => {
        if (err.response) {
          let newErrors = JSON.parse(JSON.stringify(defaultErrors));
          err.response.data.violations.map(error => {
            if (typeof error.parameters['{{ value }}'] !== 'undefined') {
              return newErrors.texts.push(`${error.parameters['{{ value }}']} : ${error.title}`);
            } else {
              return newErrors.texts.push(error.title);
            }
          });
          setErrors(newErrors);
        } else {
          console.error(err);
        }
        setIsLoading(false);
      },
    );
  };

  if (redirect) {
    return <Redirect to={redirect} />;
  }

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="indexed-search-create">
      <Form
        className="indexed-search-create_form"
        onSubmit={handleSubmit}
      >
        <TextArea
          errors={errors.texts}
          label="Liste de recheches"
          name="texts"
          onChange={handleChange}
          style={{ width: '100%' }}
          value={indexedSearchCreate.texts}
          tips="Une recherche par ligne, ou séparés par des virgules"
          rows="20"
        />

        <Button
          className="indexed-search-create_submit-button"
          label="Lancer la création des recherches"
          theme="success"
          type="submit"
        />

      </Form>
    </div>
  );
};

export default IndexedSearchCreate;
